<template>
  <div class="ui form" ref="form">
    <div class="fields">
      <div class="five wide field">
        <label for>{{ $t("project") }}</label>
        <select
          name="project"
          class="ui fluid search dropdown"
          v-model="object.project"
          ref="project_dropdown"
        ></select>
        <!-- <input type="text" name="project" v-model="object.project" /> -->
      </div>
      <div class="five wide field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="object.name" />
      </div>
      <div class="six wide field">
        <label>{{ $t("is active?") }}</label>
        <div class="ui toggle checkbox">
          <input type="checkbox" name="status" v-model="object.is_active" />
          <label>{{ $t("enable or disable robot execution") }}</label>
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("script path") }}</label>
        <div class="ui icon input">
          <input type="text" name="path" v-model="object.path" />
          <i class="search icon"></i>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("schedule (cron expression)") }}</label>
        <input type="text" name="" v-model="object.cron" />
        <span>{{ cron_to_text }}</span>
      </div>
    </div>
    <div class="field">
      <label for>{{ $t("description") }}</label>
      <textarea
        name="description"
        v-model="object.description"
        rows="2"
      ></textarea>
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import cronstrue from "cronstrue/i18n";

export default {
  name: "RobotModalGeneral",
  components: {},
  props: { robot_in: Object, projects: Array },
  data() {
    return {
      object: {
        name: "",
        project: "",
        cron: "* * * * *",
        path: "",
        description: "",
        is_active: "",
      },
    };
  },
  methods: {
    getData() {
      return this.object;
    },
    isValid() {
      return window.jQuery(this.$refs.form).form("validate form");
    },
  },
  computed: {
    cron_to_text() {
      if (this.object.cron)
        return cronstrue.toString(this.object.cron, {
          locale: this.$i18n.locale,
        });
      else return "¿?";
    },
  },
  beforeMount() {
    let vm = this;
    if (vm.robot_in && vm.robot_in.setup && vm.robot_in.setup.general) {
      vm.object = vm.robot_in.setup.general;
    }
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        project: ["empty"],
        name: ["empty"],
        path: ["empty"],
      },
    });

    if (vm.projects && vm.projects.length) {
      let vls = vm.projects.map((p) => {
        return { name: p, value: p };
      });
      window
        .jQuery(vm.$refs.project_dropdown)
        .dropdown({
          allowAdditions: true,
        })
        .dropdown("setup menu", { values: vls });

      if (vm.object.project) {
        window
          .jQuery(vm.$refs.project_dropdown)
          .dropdown("set selected", vm.object.project);
      }
    }
  },
};
</script>
